import React from 'react';
import { useAppSelector } from '../../store';
import { uniqueId } from 'lodash-es';

import craftJsParser from '../../components/utils/craftJsParser';
import { DataElementContext } from '../common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';
import { useMediaQuery } from '@/components/utils/useQueryMedia';

export const defaultProps = {
  properties: {
    elementId: null,
  },
};

export const ElementData = (componentProps) => {
  let props = componentProps;

  const [__id] = React.useState(uniqueId('unique-'));
  const componentsElements = useAppSelector((state) => state.templatesConfig.componentsElements);
  const authenticated = useAppSelector((state) => state.authentication && state.authentication.auth_type === 'user');

  const dataElementContext = React.useContext(DataElementContext);
  let isVisible = true;

  const isTablet = useMediaQuery(`(min-width: ${window.config.breakpointTablet})`);
  const isDesktop = useMediaQuery(`(min-width: ${window.config.breakpointDesktop})`);
  const breakpoints = React.useMemo(() => ({ isTablet, isDesktop }), [isTablet, isDesktop]);

  [props, isVisible] = processComponentProps(props, dataElementContext, breakpoints);

  const { elementId } = props.properties;
  const element = componentsElements?.[elementId];

  let content = React.useMemo(() => {
    try {
      if (!element) return null;
      const projectData = element.projectData;

      const data = JSON.parse(projectData);

      let rootNodeId = 'ROOT';

      if (rootNodeId) {
        data[rootNodeId].type = 'Fragment';
        data[rootNodeId].props = {
          'className': componentProps.className ?? '',
          'properties': {},
        };

        if (data[rootNodeId].nodes && data[rootNodeId].nodes.length === 1) {
          rootNodeId = data[rootNodeId].nodes[0];

          if (data[rootNodeId] && componentProps.className) {
            if (data[rootNodeId].props) {
              data[rootNodeId].props.className = `${componentProps.className} ${data[rootNodeId].props.className ?? ''}`.trim();
            }
          }
        }

        if (!data[rootNodeId]?.props?.properties) {
          data[rootNodeId].props.properties = {};
        }
        if (window !== window.parent) {
          data[rootNodeId].props.properties['data-cjs-n-id'] = componentProps.id;
        }

        data[rootNodeId].props.properties['data-e-id'] = elementId;

        return craftJsParser({
          craftState: data,
          rootNodeId: rootNodeId,
          pageId: elementId,
          pageType: 'componentsElements',
          options: {
            authenticated,
          },
          withProvider: true,
          children: componentProps.children ?? null,
        });
      }
    } catch (err) {
      console.error('ElementData', err);
    }
    return null;
  }, [elementId, authenticated, componentProps.children, componentProps.id, element, componentProps.className]);

  const contextValue = React.useMemo(() => {
    const skipProps = ['elementId', 'dsType', 'propFunction', 'links'];
    const contextValue = {};
    props?.properties && Object.keys(props.properties).forEach(key => {
      if (skipProps.indexOf(key) > -1) return;
      contextValue[key] = props.properties[key];
    });

    contextValue.parentContext = dataElementContext;
    contextValue.__id = __id;
    return contextValue;
  }, [componentProps, dataElementContext, componentsElements, authenticated]);

  if (!isVisible) return null;
  if (!content) return null;

  return <DataElementContext.Provider value={contextValue}>{content}</DataElementContext.Provider>;
};
